module.exports = __webpack_public_path__ + "static/headerRightBg375-9e7216ab9f67324345da5e5a49ba145b.png";